import { Directive } from 'angular-ts-decorators';

import { faCamera } from '@fortawesome/pro-solid-svg-icons';

/**
 * A directive meant to replace an image if it's request fails on the img element
 *
 * # Example
 * <pre>
 *   <img sw-img-fallback/>
 * </pre>
 */
@Directive({
  selector: '[sw-img-fallback]',
})
export class SwImgFallbackDirective {
  constructor(
    private fontawesome,
    private urlEscapeFilter,
    private $timeout: ng.ITimeoutService,
    private $element: ng.IAugmentedJQuery,
    private $scope: ng.IScope,
  ) {
    'ngInject';

    // TODO move to a parent class V6CompatibleDirective
    if (angular.version.minor < 5) {
      this.$timeout(() => {
        this.ngAfterViewInit();
      });
    }
  }

  ngAfterViewInit() {
    const fa = this.fontawesome.icon(angular.copy(faCamera), {
      transform: {
        size: 5,
        y: 4,
      },
      styles: {
        'background-color': '#79879d',
        color: '#fff',
      },
      attributes: {
        widht: 150,
        height: 300,
      },
    });

    fa.icon[1] += 256;

    this.$element.on('error', () => {
      (<HTMLImageElement>this.$element[0]).src =
        'data:image/svg+xml,' + this.urlEscapeFilter(fa.html[0]);
    });
  }
}
